import { ActionTree } from "vuex";
import { RootState } from "@/store/type";
import { UiState } from "@/store/ui/type";

import { UiMutations } from "@/store/ui/mutations";

export const actions: ActionTree<UiState, RootState> = {

  toggleLoginModal({ commit }, { open, isReloaded }) {
    commit(UiMutations.IS_TOGGLE_LOGIN, { open, isReloaded });
  },
  closeLoginModal({ commit }) {
    commit(UiMutations.CLOSE_LOGIN);
  },
  toggleMenuModal({ commit }) {
    commit(UiMutations.IS_TOGGLE_MENU);
  },
  toggleAddressModal({ commit }) {
    commit(UiMutations.IS_TOGGLE_ADDRESS_ACTION);
  },
  toggleColissimoModal({ commit }, { open, address, selectedRelais, shipmentWeight }) {
    commit(UiMutations.IS_TOGGLE_COLISSIMO_ACTION, { open, address, selectedRelais, shipmentWeight });
  },
  toggleAddressListModal({ commit }) {
    commit(UiMutations.IS_TOGGLE_ADDRESSLIST_ACTION);
  },
  closeMenuModal({ commit }) {
    commit(UiMutations.CLOSE_MENU);
  },
  toggleSearch({ commit }) {
    commit(UiMutations.IS_TOGGLE_SEARCH);
  },
  closeSearch({ commit }) {
    commit(UiMutations.CLOSE_SEARCH);
  },
  openSearch({ commit }) {
    commit(UiMutations.OPEN_SEARCH);
  },
  toggleCartSidebar({ commit }) {
    commit(UiMutations.IS_TOGGLE_CART);
  },
  toggleProductsActionModal({ commit }, { open, type, product }) {
    commit(UiMutations.IS_TOGGLE_PRODUCTS_ACTION, { open, type, product });
  },
  toggleNoStockActionModal({ commit }, { open, products }) {
    commit(UiMutations.IS_TOGGLE_NOSTOCK_ACTION, { open, products });
  },

  setIndexGallery({ commit }, { index }) {
    commit(UiMutations.CHANGE_INDEX, { index });
  },

  setProductGallery({ commit }, { gallery }) {
    commit(UiMutations.GET_GALLERY, { gallery });
  },
  toggleWelcomeModal({ commit }, { open, customer }) {
    commit(UiMutations.IS_TOGGLE_WELCOME_ACTION, { open, customer });

  },
  toggleResetModal({ commit }, { open, email, status }) {
    commit(UiMutations.IS_TOGGLE_RESET_ACTION, { open, email, status });

  },
  sendNotification({ commit, dispatch }, notification) {
    const id = Symbol();
    commit(UiMutations.SEND_NOTIFICATIONS, { notification, id });
    setTimeout(() => {
      dispatch("dismissNotification", id);
    }, 3000);
  },
  dismissNotification({ commit }, id) {
    commit(UiMutations.DISMIS_NOTIFICATIONS, id);
  },
  setCurrentLocal({ commit }, locale) {
    commit(UiMutations.SET_CURRENT_LOCAL, locale);
  },
};